import { ArrowDropDown } from "@mui/icons-material";
import { Box, IconButton, Paper } from "@mui/material";
import { Button, Typography } from "@procore/core-react";
import { useState } from "react";

export interface CoachmarkProps {
    label: string;
    description?: string;
    buttonLabel?: string;
    onButtonClick?: () => void;
    visible: boolean;
}

export function Coachmark({ label, description, buttonLabel, onButtonClick, visible }: CoachmarkProps) {
    const [expanded, setExpanded] = useState(false);
    const hasExpandableContent = Boolean(description || (buttonLabel && onButtonClick));

    return (
        <Paper
            sx={{
                position: "absolute",
                top: "16px",
                left: "50%",
                translate: "-50% 0",
                borderRadius: "4px",
                padding: "4px",
                background: "rgba(0, 0, 0, 0.8)",
                color: "white",
                transition: "opacity 0.2s",
                pointerEvents: visible ? "auto" : "none",
                opacity: visible ? 1 : 0,
                zIndex: 1050,
                display: "flex",
                gap: "0.5rem",
                maxWidth: "240px",
                letterSpacing: "0.25px",
            }}
        >
            {hasExpandableContent && (
                <IconButton
                    sx={{
                        borderRadius: "4px",
                        background: "#3E3E3E",
                        color: "white",
                        alignSelf: "start",
                        "&:hover": { background: "#3E3E3E" },
                        height: "24px",
                        width: "24px",
                    }}
                    onClick={() => setExpanded((prev) => !prev)}
                    size="small"
                >
                    <ArrowDropDown sx={{ rotate: expanded ? "180deg" : "0deg", transition: "rotate 0.2s" }} />
                </IconButton>
            )}
            <Box sx={{ gap: "2px", display: "flex", flexDirection: "column", flex: 1 }}>
                <Typography weight="semibold" color="white">
                    {label}
                </Typography>
                {expanded && description && <Typography color="white">{description}</Typography>}
                {expanded && buttonLabel && onButtonClick && (
                    <Button
                        variant="tertiary"
                        size="sm"
                        onClick={onButtonClick}
                        style={{ background: "#3E3E3E", color: "white", alignSelf: "flex-start", minWidth: "auto" }}
                    >
                        {buttonLabel}
                    </Button>
                )}
            </Box>
        </Paper>
    );
}
